import {
  Layout,
  Menu,
  Row,
  Col,
  Dropdown,
  Drawer,
  Input,
  Space,
  Badge,
  Spin,
  BackTop,
} from "antd";
import { Avatar } from "antd";
import {
  UserOutlined,
  MenuOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import React, { useState, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import styled from "@xstyled/styled-components";
import AppTheme from "../../theme/AppTheme";
import moment from "moment";
import { UserRequest, AppName } from "../../components";
import { authContext } from "../../providers";
import { MenuMode } from "antd/lib/menu";
import { Link, useRouteMatch } from "react-router-dom";

type Props = {
  className?: string;
  fixed?: boolean;
};

const { Header, Content, Footer } = Layout;

const UsergroupAddOutlinedStyled = styled(UsergroupAddOutlined)`
  color: ${AppTheme.colors.primary};
  font-size: 24px;
`;

const AvatarIcon = styled(UserOutlined)`
  font-size: 32px;
`;

const UserMenu: React.SFC = (props) => {
  const { dispatch } = useContext(authContext);
  return (
    <Menu>
      <Menu.Item key="0">
        <a href="/">Account settings</a>
      </Menu.Item>
      <Menu.Item key="1">
        <Link to="/gallery">Gallery</Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        onClick={() => {
          dispatch({ type: "logout" });
        }}
        key="3"
      >
        Logout
      </Menu.Item>
    </Menu>
  );
};

const userRequests = () => {
  return (
    <Menu>
      <Menu.Item>
        <UserRequest />
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <UserRequest />
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <UserRequest />
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item className="text-center">
        <span className="font-bold uppercase m-2 inline-block">View all</span>
      </Menu.Item>
    </Menu>
  );
};

const TopMenu: React.FC<{ mode: MenuMode; authenticated: boolean }> = (
  props
) => {
  const isLg = useMediaQuery({ query: "(min-width: 1024px)" });

  let { path } = useRouteMatch();

  return (
    <>
      <Col flex="auto">
        <Menu theme="light" mode={props.mode} defaultSelectedKeys={[path]}>
          <Menu.Item key="/family-tree">
            <Link to="/family-tree">Family Tree</Link>
          </Menu.Item>
          <Menu.Item key="/search">
            <Link to="/search">Search</Link>
          </Menu.Item>
          <Menu.Item key="1">
            <Link to="/gallery">Memories</Link>
          </Menu.Item>
        </Menu>
      </Col>
      {props.authenticated && (
        <Col>
          <Space
            size={20}
            direction={isLg ? "horizontal" : "vertical"}
            className={clsx({
              "px-2": isLg,
              "ant-space-item-w-full w-full px-4 py-2": !isLg,
            })}
            align={isLg ? "end" : "center"}
          >
            <Input
              className="rounded-full"
              placeholder="Looking for someone?"
              suffix={<SearchOutlined />}
            />
            <Badge overflowCount={99} count={3} style={{ fontSize: "10px" }}>
              <Dropdown
                placement={isLg ? "bottomLeft" : "bottomCenter"}
                overlay={userRequests}
                trigger={["click"]}
              >
                <UsergroupAddOutlinedStyled className="cursor-pointer" />
              </Dropdown>
            </Badge>
            <Dropdown
              placement={isLg ? "bottomLeft" : "bottomCenter"}
              overlay={<UserMenu />}
              trigger={["click"]}
            >
              <Avatar
                className="cursor-pointer"
                size={"large"}
                icon={<AvatarIcon />}
              />
            </Dropdown>
          </Space>
        </Col>
      )}
    </>
  );
};

const Main: React.FC<Props> = (props) => {
  const isLg = useMediaQuery({ query: "(min-width: 1024px)" });
  const isSm = useMediaQuery({ query: "(min-width: 640px)" });

  const [drawerVisible, setDrawerVisible] = useState(false);

  const { auth } = useContext(authContext);

  return (
    <Spin
      className="w-screen h-screen"
      size="large"
      spinning={auth.loading === true}
    >
      <Layout
        className={`layout flex bg-transparent w-screen h-screen ${
          props.className ?? ""
        }`}
      >
        <Header
          style={
            props.fixed === true
              ? { position: "fixed", zIndex: 1, width: "100%" }
              : undefined
          }
          className="bg-white"
          color="white"
        >
          <Row>
            <Col
              flex={isLg ? undefined : "auto"}
              className="text-lg inline mr-0 sm:mr-8"
            >
              <Link to="/">
                <AppName />
              </Link>
            </Col>
            {isLg && (
              <>
                <TopMenu
                  mode="horizontal"
                  authenticated={auth.data !== undefined}
                />
              </>
            )}

            {!isLg && (
              <Col>
                <MenuOutlined
                  onClick={() => {
                    setDrawerVisible(true);
                  }}
                />
              </Col>
            )}
          </Row>
          <Drawer
            title={<AppName />}
            placement="right"
            bodyStyle={{ padding: "0px" }}
            closable={true}
            onClose={() => {
              setDrawerVisible(false);
            }}
            visible={!isLg && drawerVisible}
            key="left"
          >
            <TopMenu mode="inline" authenticated={auth.data !== undefined} />
          </Drawer>
        </Header>
        <main
          className="overflow-y-auto overflow-x-hidden"
          style={{
            marginTop: props.fixed === true ? 64 : 0,
          }}
        >
          <Content
            style={{
              padding: isSm ? "0 50px" : undefined,
            }}
          >
            <div className="site-layout-content">{props.children}</div>
          </Content>
          <Footer className="text-center bg-transparent">
            <span className="uppercase">
              <span className="font-light">Origin</span>
              <span className="font-bold">records</span>
            </span>{" "}
            ©{moment().year()} Created by Wottaspace
          </Footer>
          <BackTop />
        </main>
      </Layout>
    </Spin>
  );
};

export default Main;
